/*
 * @Author: 王峥 wangzheng_jzb@tal.com
 * @Date: 2024-10-15 17:58:35
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @LastEditTime: 2024-11-19 15:15:28
 * @FilePath: /fe-react-template/src/service/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@utils/request';

const login = async (params: IApi.LoginParams) => {
    // const { corpId } = params
    try {
        // const res = await getAuthCode(corpId)
        const res = { code: 'test' };
        const { data } = await request.post<IHomeStore.TeamInfo>('/auth/login', res.code);
        return data;
    } catch (e) {
        console.log(e);
    }
};

const getListApi = async () => {
    try {
        const res = await request.post<IHomeStore.TeamInfo>('/usergroup/group/silence');
        return res;
    } catch (error) {
        console.log(error);
    }
};
// 秘钥获取接口
const getSec = async (params:{talId:number}) => { 
    
    try{
        return await request.post<IHomeStore.TeamInfo>('/parent-server/common/sec/get',params);
    }
    catch(e){
        console.log(e);
    }
}

export { login, getListApi,getSec };
